export const header = () => ({
    padding: '0 0 20px',
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    gridColumnGap: 16,
});
